/**
 * Dynamic Product Carousel — shared init (section-product-v1 + PDP mobile bands).
 */
(function () {
  'use strict';

  var initialized = new WeakSet();

  function getCards(track) {
    return Array.from(track.querySelectorAll('.tcn-carousel-card'));
  }

  function getTrackGap(track) {
    var style = getComputedStyle(track);
    return parseFloat(style.columnGap || style.gap) || 0;
  }

  function scrollLeftForIndex(track, index) {
    var cards = getCards(track);
    if (!cards.length) return 0;
    var gap = getTrackGap(track);
    var left = 0;
    for (var i = 0; i < index; i++) {
      left += cards[i].offsetWidth + gap;
    }
    return left;
  }

  function getCurrentIndex(track) {
    var cards = getCards(track);
    if (!cards.length) return 0;
    var scrollLeft = track.scrollLeft;
    var index = 0;
    for (var i = cards.length - 1; i >= 0; i--) {
      if (scrollLeft >= scrollLeftForIndex(track, i) - 4) {
        index = i;
        break;
      }
    }
    return index;
  }

  function scrollToIndex(track, index) {
    var cards = getCards(track);
    if (!cards.length) return;
    var i = Math.max(0, Math.min(cards.length - 1, index));
    track.scrollTo({
      left: scrollLeftForIndex(track, i),
      behavior: 'smooth'
    });
  }

  function setSelectedCard(track, card) {
    getCards(track).forEach(function (c) {
      c.classList.toggle('tcn-carousel-card--selected', c === card);
    });
  }

  function canShowAltImage() {
    return (
      window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
      window.matchMedia('(min-width: 1025px)').matches
    );
  }

  function clearAltImages(track) {
    track.querySelectorAll('.tcn-carousel-image-wrapper').forEach(function (w) {
      w.classList.remove('tcn-carousel-image--show-alt');
    });
  }

  function showAltImage(track, imageWrap) {
    if (!canShowAltImage()) {
      clearAltImages(track);
      return;
    }
    clearAltImages(track);
    if (imageWrap) imageWrap.classList.add('tcn-carousel-image--show-alt');
  }

  function initWrapper(wrapper) {
    if (!wrapper || initialized.has(wrapper)) return;

    var track = wrapper.querySelector('.tcn-carousel-track');
    if (!track) return;

    var btnNext = wrapper.querySelector('.tcn-carousel-next');
    var btnPrev = wrapper.querySelector('.tcn-carousel-prev');
    var thumb = wrapper.querySelector('.tcn-carousel-scroll-thumb');
    var scrollBar = wrapper.querySelector('.tcn-carousel-scroll-bar');

    if (!btnNext || !btnPrev || !thumb || !scrollBar) return;

    initialized.add(wrapper);

    var imageTap = null;

    function stepCarousel(direction) {
      scrollToIndex(track, getCurrentIndex(track) + direction);
    }

    function updateScrollBar() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        thumb.style.transform = 'translateX(0)';
        return;
      }
      var scrollRatio = track.scrollLeft / maxScroll;
      var maxOffset = scrollBar.clientWidth - thumb.clientWidth;
      thumb.style.transform = 'translateX(' + scrollRatio * maxOffset + 'px)';
    }

    btnNext.addEventListener('click', function (e) {
      e.preventDefault();
      stepCarousel(1);
    });

    btnPrev.addEventListener('click', function (e) {
      e.preventDefault();
      stepCarousel(-1);
    });

    track.addEventListener('scroll', updateScrollBar);

    track.addEventListener('click', function (e) {
      var imageWrap = e.target.closest('.tcn-carousel-image-wrapper');
      if (imageWrap) {
        var card = imageWrap.closest('.tcn-carousel-card');
        if (card) setSelectedCard(track, card);
        showAltImage(track, imageWrap);
        return;
      }
      var titleLink = e.target.closest('.tcn-carousel-title-link');
      if (titleLink) {
        var cardFromLink = titleLink.closest('.tcn-carousel-card');
        if (cardFromLink) setSelectedCard(track, cardFromLink);
      }
    });

    track.addEventListener(
      'touchstart',
      function (e) {
        var wrap = e.target.closest('.tcn-carousel-image-wrapper, .tcn-carousel-image');
        if (!wrap) return;
        var imageWrap = wrap.closest('.tcn-carousel-image-wrapper') || wrap;
        var card = imageWrap.closest('.tcn-carousel-card');
        if (!card) return;
        imageTap = {
          card: card,
          imageWrap: imageWrap,
          x: e.touches[0].clientX,
          y: e.touches[0].clientY,
          moved: false
        };
      },
      { passive: true }
    );

    track.addEventListener(
      'touchmove',
      function (e) {
        if (!imageTap) return;
        var dx = e.touches[0].clientX - imageTap.x;
        var dy = e.touches[0].clientY - imageTap.y;
        if (Math.abs(dx) > 10 || Math.abs(dy) > 10) imageTap.moved = true;
      },
      { passive: true }
    );

    function endImageTap() {
      if (imageTap && !imageTap.moved && imageTap.card) {
        setSelectedCard(track, imageTap.card);
      }
      imageTap = null;
    }

    track.addEventListener('touchend', endImageTap, { passive: true });
    track.addEventListener(
      'touchcancel',
      function () {
        imageTap = null;
      },
      { passive: true }
    );

    track.querySelectorAll('.tcn-carousel-title-link').forEach(function (link) {
      link.addEventListener('focus', function () {
        var card = link.closest('.tcn-carousel-card');
        if (card) setSelectedCard(track, card);
      });
    });

    window.addEventListener('resize', updateScrollBar);
    updateScrollBar();
  }

  function boot() {
    document
      .querySelectorAll('.tcn-carousel-wrapper--dynamic[data-tcn-dynamic-carousel]')
      .forEach(initWrapper);
  }

  window.TcnDynamicCarousel = {
    init: function (root) {
      if (!root) {
        boot();
        return;
      }
      initialized.delete(root);
      initWrapper(root);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
